<div class="row">
  @if (showShoppingCart) {
    <div [ngClass]="(showShoppingCart)?'col-md-6 col-md-push-6 col-sm-12':''">
      <h3 name="payment-method-title">{{'REGISTRATION.STEP.PAYMENT.CART' | translate}}</h3>
      <div class="row">
        <div class="col-md-12">
          <app-shopping-cart [selectedSubscription]="selectedSubscription()" [selectedDiscount]="selectedDiscount"
            [selectedOptions]="selectedOptions()" #shoppingCart>
          </app-shopping-cart>
        </div>
      </div>
    </div>
  }
  <div [ngClass]="(showShoppingCart)?'col-md-6 col-md-pull-6 col-sm-12':'col-md-12 col-sm-12'">
    @if (!selectedSubscription().alreadyOwnWatch) {
      <div>
        <h3>{{'REGISTRATION.STEP.PAYMENT.TITLE' | translate}}</h3>
      </div>
    } @else {
      @if (!selectedSubscription().alreadyOwnWatch || selectedOptions().length > 0) {
        <div>
          <h3>{{'REGISTRATION.STEP.PAYMENT.TITLE' | translate}}</h3>
        </div>
      } @else {
        <h3>{{'REGISTRATION.PAYMENT.SAVE_PAYMENT_INFOS' | translate}}</h3>
      }
    }
    <div class="col-md-12" class="padding-bottom">
      <mat-button-toggle-group name="paymentButtonGroup" [vertical]="true" [(ngModel)]="type" class="full-width">
        <mat-button-toggle value="card" name="cb" class="full-width center">
          {{'REGISTRATION.STEP.PAYMENT.CB.NAME' | translate}}
        </mat-button-toggle>
        <mat-button-toggle value="sepa" (click)="setSepaForm()" name="sepa" class="full-width center">
          {{'REGISTRATION.STEP.PAYMENT.SEPA.NAME' | translate}}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    @if (type==='card') {
      <form method="POST" [formGroup]="cardFormGroup">
        <input type="hidden" formControlName="productID">
        <div class="col-md-6 col-sd-12">
          <mat-form-field class="full-width">
            <mat-label>{{'REGISTRATION.PAYMENT.CARD_NUMBER' | translate}}</mat-label>
            <input matInput formControlName="number" name="number" autocomplete="cc-number" required
              class="full-width" type="text" [mask]="paymentMethodValidator.getCardMask()"
              [validation]="false">
            @if (cardFormGroup.get('number').hasError('required') && cardFormGroup.get('number').touched) {
              <mat-error
                >
                {{getErrorMessage('REGISTRATION.PAYMENT.CARD_NUMBER')}}
              </mat-error>
            }
            @if (cardFormGroup.get('number').hasError('invalidCard') && cardFormGroup.get('number').touched) {
              <mat-error
                >
                {{ 'REGISTRATION.FORM.INVALID_CARD_NUMBER' | translate}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-6 col-sm-12">
          <app-display-card-type [cardNumber]="card.number"></app-display-card-type>
        </div>
        <div class="col-md-12">
          <mat-form-field class="full-width">
            <mat-label>{{'REGISTRATION.PAYMENT.CARD_OWNER' | translate}}</mat-label>
            <input matInput formControlName="holderName" name="ccname" type="text" size="20"
              autocomplete="cc-name" required class="full-width">
            @if (cardFormGroup.get('holderName').hasError('required') && cardFormGroup.get('holderName').touched) {
              <mat-error
                >
                {{getErrorMessage('REGISTRATION.PAYMENT.CARD_OWNER')}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <input type="text" class="workaround" formControlName="expiryMonth" autocomplete="cc-exp-month">
          <mat-form-field class="full-width">
            <mat-label>{{'REGISTRATION.PAYMENT.EXPIRATION_MONTH' | translate}}</mat-label>
            <mat-select formControlName="expiryMonth" autocomplete=" cc-exp-month" name="cc-exp-month" required
              class="mat-primary">
              @for (month of months; track month) {
                <mat-option [value]="month">
                  {{month}}
                </mat-option>
              }
            </mat-select>
            @if (cardFormGroup.get('expiryMonth').hasError('required') && cardFormGroup.get('expiryMonth').touched) {
              <mat-error
                >
                {{getErrorMessage('REGISTRATION.PAYMENT.EXPIRATION_MONTH')}}
              </mat-error>
            }
            @if (cardFormGroup.get('expiryMonth').hasError('invalidExpiryDate') && cardFormGroup.get('expiryMonth').touched) {
              <mat-error
                >
                {{ 'REGISTRATION.FORM.INVALID_EXPIRY_DATE' | translate}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <input type="text" class="workaround" formControlName="expiryYear" autocomplete="cc-exp-year">
          <mat-form-field class="full-width">
            <mat-label>{{'REGISTRATION.PAYMENT.EXPIRATION_YEAR' | translate}}</mat-label>
            <mat-select formControlName="expiryYear" autocomplete="cc-exp-year" name="cc-exp-year" required
              class="mat-primary">
              @for (year of years; track year) {
                <mat-option [value]="year">
                  {{year}}
                </mat-option>
              }
            </mat-select>
            @if (cardFormGroup.get('expiryYear').hasError('required') && cardFormGroup.get('expiryYear').touched) {
              <mat-error
                >
                {{getErrorMessage('REGISTRATION.PAYMENT.EXPIRATION_YEAR')}}
              </mat-error>
            }
            @if (cardFormGroup.get('expiryYear').hasError('invalidExpiryDate') && cardFormGroup.get('expiryYear').touched) {
              <mat-error
                >
                {{ 'REGISTRATION.FORM.INVALID_EXPIRY_DATE' | translate}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field class="full-width">
            <mat-label>{{'REGISTRATION.PAYMENT.CODE' | translate}}</mat-label>
            <input matInput formControlName="cvc" name="cvc" type="text" autocomplete="cc-csc" class="cvc-marg"
              required>
            <mat-icon matSuffix [matTooltip]="'REGISTRATION.PAYMENT.INFO_CODE' | translate">info</mat-icon>
            @if (cardFormGroup.get('cvc').hasError('required') && cardFormGroup.get('cvc').touched) {
              <mat-error
                >
                {{getErrorMessage('REGISTRATION.PAYMENT.CODE')}}
              </mat-error>
            }
            @if (cardFormGroup.get('cvc').hasError('invalidCvc') && cardFormGroup.get('cvc').touched) {
              <mat-error
                >
                {{ 'REGISTRATION.FORM.INVALID_CODE_NUMBER' | translate}}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </form>
    }
    @if (type==='sepa' && sepaFormGroup) {
      <form [formGroup]="sepaFormGroup">
        <div class="col-md-12">
          <mat-form-field class="full-width">
            <mat-label>{{'REGISTRATION.STEP.PAYMENT.SEPA.IBAN' | translate}}</mat-label>
            <input matInput name="iban" formControlName="iban" type="text" autocomplete="off" appUpperCase
              required class="full-width" [mask]="paymentMethodValidator.getIbanMask()" [validation]="false">
            @if (sepaFormGroup.get('iban').hasError('required') && sepaFormGroup.get('iban').touched) {
              <mat-error
                >
                {{getErrorMessage('REGISTRATION.STEP.PAYMENT.SEPA.IBAN')}}
              </mat-error>
            }
            @if (sepaFormGroup.get('iban').hasError('invalidIban') && sepaFormGroup.get('iban').touched) {
              <mat-error
                >
                {{'REGISTRATION.STEP.PAYMENT.SEPA.IBAN_INVALID' |translate}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field class="full-width">
            <mat-label>{{'COMMON.CIVILITY' | translate}}</mat-label>
            <mat-select formControlName="gender" name="gender" class="full-width">
              @for (gender of ['MALE', 'FEMALE']; track gender) {
                <mat-option [value]="gender.toLowerCase()">
                  {{ 'COMMON.'+gender | translate }}
                </mat-option>
              }
            </mat-select>
            @if (sepaFormGroup.get('gender').touched && !isValid('gender')) {
              <mat-error>
                {{getErrorMessage('COMMON.CIVILITY')}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field class="full-width">
            <mat-label>{{'REGISTRATION.STEP.PAYMENT.SEPA.LAST_NAME' | translate}}</mat-label>
            <input matInput formControlName="lastName" name="lastName" type="text" autocomplete="family-name"
              required class="full-width">
            @if (sepaFormGroup.get('lastName').touched && !isValid('lastName')) {
              <mat-error>
                {{getErrorMessage('REGISTRATION.STEP.PAYMENT.SEPA.LAST_NAME')}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-5">
          <mat-form-field class="full-width">
            <mat-label>{{'REGISTRATION.STEP.PAYMENT.SEPA.FIRST_NAME' | translate}}</mat-label>
            <input matInput formControlName="firstName" name="firstName" type="text" autocomplete="given-name"
              required class="full-width">
            @if (sepaFormGroup.get('firstName').touched && !isValid('firstName')) {
              <mat-error>
                {{getErrorMessage('REGISTRATION.STEP.PAYMENT.SEPA.FIRST_NAME')}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-md-12" formGroupName="mandateAddress">
          <mat-form-field class="full-width">
            <mat-label>{{'COMMON.USER_INFO.ADDRESS' | translate}}</mat-label>
            <app-address-autocomplete name="address" formControlName="addressRaw"
            (placeChanged)="onAutocompleteSelected($event)"></app-address-autocomplete>
            @if (sepaFormGroup.get('mandateAddress').touched && !sepaFormGroup.get('mandateAddress').get('addressRaw').valid) {
              <mat-error
                >
                {{getErrorMessage('REGISTRATION.STEP.PAYMENT.SEPA.ADDRESS') }}
              </mat-error>
            }
            @if (sepaFormGroup.get('mandateAddress').touched && sepaFormGroup.get('mandateAddress').get('addressRaw').valid && !sepaFormGroup.get('mandateAddress').get('street').valid) {
              <mat-error
                >
                {{'REGISTRATION.STEP.PAYMENT.SEPA.ADDRESS_INVALID' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </form>
    }

    @if (type===null) {
      <div>
        <h5>{{'REGISTRATION.STEP.PAYMENT.MAKE_PAYMENT_CHOICE' | translate}}</h5>
      </div>
    }
    @if (type!==null && showDiscountCode()) {
      <div class="col-md-12 col-sm-12">
        <app-discount-code (emittedValue)="priceCorrection($event)"></app-discount-code>
      </div>
    }
  </div>
</div>
